(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7610],{

/***/ 41314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[channelPath]/[categoryCode]",
      function () {
        return __webpack_require__(8680);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RA": function() { return /* binding */ verifyAuth; },
/* harmony export */   "bG": function() { return /* binding */ sendAuthOtp; },
/* harmony export */   "et": function() { return /* binding */ getUserProfile; },
/* harmony export */   "kS": function() { return /* binding */ logout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61619);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);






/**
 * send otp to verify mobile number for authentication
 * @param mobileNo target mobile number
 * @param lang otp langauge message
 * @returns reference number otp and is found user in retail platform flag
 */ var sendAuthOtp = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(mobileNo, lang) {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post("/api/retail/auth/send-otp", {
                            mobileNo: mobileNo
                        }, {
                            headers: {
                                "Accept-Language": lang
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function sendAuthOtp(mobileNo, lang) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * get user profile from access token in cookies
 * @returns user's profile
 */ var getUserProfile = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().get("/api/retail/auth/user/me")
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getUserProfile() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Function to verify authentication.
 * @return atk, rtk, isAlreadyRegistered and expired datetime
 */ var verifyAuth = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(payload) {
        var res, result, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post("/api/retail/auth/login", payload)
                    ];
                case 1:
                    res = _state.sent();
                    result = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, res.data), {
                        timestamp: res.headers.date
                    });
                    return [
                        2,
                        result
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function verifyAuth(payload) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * logout by access token in cookies
 * @returns empty object
 */ var logout = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var res, error, errorUnwrap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post("/api/retail/auth/logout", {}, {
                            withCredentials: true,
                            headers: {
                                credentials: "same-origin"
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,src_utils_axiosError__WEBPACK_IMPORTED_MODULE_3__/* .axiosErrorUnwrap */ .h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function logout() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 94665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_api_auth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36707);
/* harmony import */ var src_constants_layout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(435);
/* harmony import */ var src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85760);










// allow user or guest to access this page
// if user is authorized, header will display user header with user data to child component.
// if user not authorized, header will display guest header and able to log in/sign up.
var withUserOrGuest = function(WrappedComponent) {
    return function(props) {
        var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
        var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), user = ref[0], setUser = ref[1];
        var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoadSuccess = ref1[0], setIsLoadSuccess = ref1[1];
        var isRetail = src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_3__/* .LOGICAL_GROUP_CHANNEL_CODE */ .V === src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_3__/* .RETAIL_LOGICAL_GROUP_CHANNEL_CODE */ .b;
        (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
            var fetchGetProfile = function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var result, err;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0,src_api_auth__WEBPACK_IMPORTED_MODULE_6__/* .getUserProfile */ .et)()
                                ];
                            case 1:
                                result = _state.sent();
                                setUser(result);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                setUser(null);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                setIsLoadSuccess(true);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchGetProfile() {
                    return _ref.apply(this, arguments);
                };
            }();
            // fetch user data once only, prevent unnecessary fetch from other state.
            if (!isLoadSuccess) {
                fetchGetProfile();
            }
        }, [
            isLoadSuccess,
            router
        ]);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: isLoadSuccess && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
                user: user,
                headerType: isRetail ? src_constants_layout__WEBPACK_IMPORTED_MODULE_9__/* .HEADER_TYPE.PROFILE */ .N.PROFILE : src_constants_layout__WEBPACK_IMPORTED_MODULE_9__/* .HEADER_TYPE.PARTNER */ .N.PARTNER
            }))
        });
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withUserOrGuest);


/***/ }),

/***/ 18643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ ENTRY_FORM_CODE; },
/* harmony export */   "_": function() { return /* binding */ ENTRY_FORM_INPUT_CODE; }
/* harmony export */ });
var ENTRY_FORM_CODE = {
    HEALTH_BASIC_ENTRY_FORM: "health-basic-entry-form",
    MOTOR_BASIC_ENTRY_FORM: "motor-basic-entry-form",
    HEALTH_REVISED_CONTENT_ENTRY_FORM: "health-revised-content-entry-form"
};
var ENTRY_FORM_INPUT_CODE = {
    EFFECTIVE_DATE: "effectiveDate",
    INSURED_DATE_OF_BIRTH: "insuredDateOfBirth",
    INSURED_GENDER: "insuredGender",
    INSURED_MARITAL_STATUS: "maritalStatus"
};


/***/ }),

/***/ 8680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _categoryCode_; }
});

// EXTERNAL MODULE: ./src/components/Layout/withLayout.tsx + 6 modules
var withLayout = __webpack_require__(20587);
// EXTERNAL MODULE: ./src/components/Auth/withUserOrGuest.tsx
var withUserOrGuest = __webpack_require__(94665);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/constants/entryForm.ts
var constants_entryForm = __webpack_require__(18643);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/ProductCategoryPage/index.tsx




var EntryFormBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5342).then(__webpack_require__.bind(__webpack_require__, 35342));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35342)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var ContactUs = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 539).then(__webpack_require__.bind(__webpack_require__, 20539));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20539)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var PartnerHealthProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9722), __webpack_require__.e(211), __webpack_require__.e(5881)]).then(__webpack_require__.bind(__webpack_require__, 95881));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95881)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var PartnerHealthTopupProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9722), __webpack_require__.e(211), __webpack_require__.e(3608)]).then(__webpack_require__.bind(__webpack_require__, 63608));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63608)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var THGPAProductCateogryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1549), __webpack_require__.e(3436), __webpack_require__.e(8792), __webpack_require__.e(1469), __webpack_require__.e(2873), __webpack_require__.e(6203), __webpack_require__.e(9133), __webpack_require__.e(9722), __webpack_require__.e(5214), __webpack_require__.e(4340)]).then(__webpack_require__.bind(__webpack_require__, 54340));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(54340)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var PartnerPAProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1549), __webpack_require__.e(3436), __webpack_require__.e(8792), __webpack_require__.e(1469), __webpack_require__.e(2873), __webpack_require__.e(6203), __webpack_require__.e(9133), __webpack_require__.e(9722), __webpack_require__.e(5214), __webpack_require__.e(6913)]).then(__webpack_require__.bind(__webpack_require__, 22164));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22164)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var ChildHealthProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1549), __webpack_require__.e(3436), __webpack_require__.e(8792), __webpack_require__.e(1469), __webpack_require__.e(2873), __webpack_require__.e(6203), __webpack_require__.e(9133), __webpack_require__.e(7751), __webpack_require__.e(9722), __webpack_require__.e(300)]).then(__webpack_require__.bind(__webpack_require__, 76641));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76641)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var CriticalIllnessProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9722), __webpack_require__.e(319), __webpack_require__.e(4332)]).then(__webpack_require__.bind(__webpack_require__, 24332));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24332)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var PartnerCriticalIllnessProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9722), __webpack_require__.e(319), __webpack_require__.e(5004)]).then(__webpack_require__.bind(__webpack_require__, 45004));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45004)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var ScbForeignWorkerPAProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1549), __webpack_require__.e(3436), __webpack_require__.e(8792), __webpack_require__.e(1469), __webpack_require__.e(2873), __webpack_require__.e(6203), __webpack_require__.e(9133), __webpack_require__.e(9722), __webpack_require__.e(5214), __webpack_require__.e(2090)]).then(__webpack_require__.bind(__webpack_require__, 72090));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72090)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var HealthProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1509), __webpack_require__.e(3917), __webpack_require__.e(768), __webpack_require__.e(8837), __webpack_require__.e(5865), __webpack_require__.e(3247), __webpack_require__.e(5518), __webpack_require__.e(6519), __webpack_require__.e(7784), __webpack_require__.e(1173), __webpack_require__.e(3140), __webpack_require__.e(9474), __webpack_require__.e(6434), __webpack_require__.e(9722), __webpack_require__.e(4811), __webpack_require__.e(1929), __webpack_require__.e(1515), __webpack_require__.e(4486), __webpack_require__.e(5031)]).then(__webpack_require__.bind(__webpack_require__, 95031));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95031)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var HealthTopUpProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9722), __webpack_require__.e(4486), __webpack_require__.e(430)]).then(__webpack_require__.bind(__webpack_require__, 20430));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20430)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var KSCChildHealthProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1549), __webpack_require__.e(3436), __webpack_require__.e(8792), __webpack_require__.e(1469), __webpack_require__.e(2873), __webpack_require__.e(6203), __webpack_require__.e(9133), __webpack_require__.e(7751), __webpack_require__.e(9722), __webpack_require__.e(3976)]).then(__webpack_require__.bind(__webpack_require__, 66573));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66573)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var KSCHealthProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9722), __webpack_require__.e(7343)]).then(__webpack_require__.bind(__webpack_require__, 27343));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27343)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var KSCHealthTopUpProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9722), __webpack_require__.e(4486), __webpack_require__.e(8999)]).then(__webpack_require__.bind(__webpack_require__, 58999));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58999)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var HGDHealthProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1549), __webpack_require__.e(3436), __webpack_require__.e(8792), __webpack_require__.e(1469), __webpack_require__.e(2873), __webpack_require__.e(6203), __webpack_require__.e(9133), __webpack_require__.e(7972)]).then(__webpack_require__.bind(__webpack_require__, 39786));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39786)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var PAProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1549), __webpack_require__.e(3436), __webpack_require__.e(8792), __webpack_require__.e(1469), __webpack_require__.e(2873), __webpack_require__.e(6203), __webpack_require__.e(9133), __webpack_require__.e(9722), __webpack_require__.e(5214), __webpack_require__.e(7875)]).then(__webpack_require__.bind(__webpack_require__, 97875));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97875)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var HGDCriticalIllnessProductCategoryDetail = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 630).then(__webpack_require__.bind(__webpack_require__, 20630));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20630)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var HGDPAProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1549), __webpack_require__.e(3436), __webpack_require__.e(8792), __webpack_require__.e(1469), __webpack_require__.e(2873), __webpack_require__.e(6203), __webpack_require__.e(9133), __webpack_require__.e(3209)]).then(__webpack_require__.bind(__webpack_require__, 9576));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9576)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var HGDHealthTopUpProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1549), __webpack_require__.e(3436), __webpack_require__.e(8792), __webpack_require__.e(1469), __webpack_require__.e(2873), __webpack_require__.e(6203), __webpack_require__.e(9133), __webpack_require__.e(8928)]).then(__webpack_require__.bind(__webpack_require__, 39618));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39618)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var CancerProductCategoryDetail = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9419).then(__webpack_require__.bind(__webpack_require__, 49419));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49419)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var RetailMotorProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1509), __webpack_require__.e(3917), __webpack_require__.e(768), __webpack_require__.e(8837), __webpack_require__.e(5865), __webpack_require__.e(3247), __webpack_require__.e(5518), __webpack_require__.e(6519), __webpack_require__.e(7784), __webpack_require__.e(1173), __webpack_require__.e(9474), __webpack_require__.e(6434), __webpack_require__.e(4811), __webpack_require__.e(1625), __webpack_require__.e(4075)]).then(__webpack_require__.bind(__webpack_require__, 14075));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14075)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var EvRetailMotorProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1509), __webpack_require__.e(3917), __webpack_require__.e(768), __webpack_require__.e(8837), __webpack_require__.e(5865), __webpack_require__.e(3247), __webpack_require__.e(5518), __webpack_require__.e(6519), __webpack_require__.e(7784), __webpack_require__.e(1173), __webpack_require__.e(9474), __webpack_require__.e(6434), __webpack_require__.e(4811), __webpack_require__.e(1625), __webpack_require__.e(6015)]).then(__webpack_require__.bind(__webpack_require__, 76015));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76015)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var CHUBBTravelProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1509), __webpack_require__.e(3917), __webpack_require__.e(768), __webpack_require__.e(8837), __webpack_require__.e(5865), __webpack_require__.e(3247), __webpack_require__.e(5518), __webpack_require__.e(6519), __webpack_require__.e(7784), __webpack_require__.e(1173), __webpack_require__.e(9474), __webpack_require__.e(6434), __webpack_require__.e(4811), __webpack_require__.e(1929), __webpack_require__.e(4798)]).then(__webpack_require__.bind(__webpack_require__, 84798));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84798)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var AXAChildHealthProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1509), __webpack_require__.e(3917), __webpack_require__.e(768), __webpack_require__.e(8837), __webpack_require__.e(5865), __webpack_require__.e(3247), __webpack_require__.e(5518), __webpack_require__.e(1549), __webpack_require__.e(6519), __webpack_require__.e(3436), __webpack_require__.e(7784), __webpack_require__.e(8792), __webpack_require__.e(1469), __webpack_require__.e(1173), __webpack_require__.e(2873), __webpack_require__.e(6203), __webpack_require__.e(9133), __webpack_require__.e(9474), __webpack_require__.e(6434), __webpack_require__.e(4811), __webpack_require__.e(1929), __webpack_require__.e(1515), __webpack_require__.e(9118), __webpack_require__.e(5327)]).then(__webpack_require__.bind(__webpack_require__, 58714));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58714)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var LgibHealthProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9722), __webpack_require__.e(211), __webpack_require__.e(1066)]).then(__webpack_require__.bind(__webpack_require__, 21066));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21066)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var LgibHealthTopUpProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9722), __webpack_require__.e(211), __webpack_require__.e(6906)]).then(__webpack_require__.bind(__webpack_require__, 6906));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6906)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var AXAAdultHealthProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1509), __webpack_require__.e(3917), __webpack_require__.e(768), __webpack_require__.e(8837), __webpack_require__.e(5865), __webpack_require__.e(3247), __webpack_require__.e(5518), __webpack_require__.e(6519), __webpack_require__.e(7784), __webpack_require__.e(1173), __webpack_require__.e(9474), __webpack_require__.e(6434), __webpack_require__.e(4811), __webpack_require__.e(1929), __webpack_require__.e(1515), __webpack_require__.e(9118), __webpack_require__.e(4950)]).then(__webpack_require__.bind(__webpack_require__, 70964));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(70964)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var BKIPAProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1509), __webpack_require__.e(3917), __webpack_require__.e(768), __webpack_require__.e(8837), __webpack_require__.e(5865), __webpack_require__.e(3247), __webpack_require__.e(5518), __webpack_require__.e(6519), __webpack_require__.e(7784), __webpack_require__.e(1173), __webpack_require__.e(9474), __webpack_require__.e(6434), __webpack_require__.e(4811), __webpack_require__.e(1929), __webpack_require__.e(1515), __webpack_require__.e(9118), __webpack_require__.e(6336)]).then(__webpack_require__.bind(__webpack_require__, 32927));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32927)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var MTIChildPAProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1509), __webpack_require__.e(3917), __webpack_require__.e(768), __webpack_require__.e(8837), __webpack_require__.e(5865), __webpack_require__.e(3247), __webpack_require__.e(5518), __webpack_require__.e(6519), __webpack_require__.e(7784), __webpack_require__.e(1173), __webpack_require__.e(9474), __webpack_require__.e(6434), __webpack_require__.e(4811), __webpack_require__.e(1929), __webpack_require__.e(1515), __webpack_require__.e(9118), __webpack_require__.e(4297)]).then(__webpack_require__.bind(__webpack_require__, 4682));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4682)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var MTIChildPAHealthProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1509), __webpack_require__.e(3917), __webpack_require__.e(768), __webpack_require__.e(8837), __webpack_require__.e(5865), __webpack_require__.e(3247), __webpack_require__.e(5518), __webpack_require__.e(1549), __webpack_require__.e(6519), __webpack_require__.e(3436), __webpack_require__.e(7784), __webpack_require__.e(8792), __webpack_require__.e(1469), __webpack_require__.e(1173), __webpack_require__.e(2873), __webpack_require__.e(6203), __webpack_require__.e(9133), __webpack_require__.e(9474), __webpack_require__.e(6434), __webpack_require__.e(4811), __webpack_require__.e(1929), __webpack_require__.e(1515), __webpack_require__.e(9118), __webpack_require__.e(6331)]).then(__webpack_require__.bind(__webpack_require__, 99192));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99192)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var MTIPneumoniaDengueProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1509), __webpack_require__.e(3917), __webpack_require__.e(768), __webpack_require__.e(8837), __webpack_require__.e(5865), __webpack_require__.e(3247), __webpack_require__.e(5518), __webpack_require__.e(6519), __webpack_require__.e(7784), __webpack_require__.e(1173), __webpack_require__.e(9474), __webpack_require__.e(6434), __webpack_require__.e(4811), __webpack_require__.e(1929), __webpack_require__.e(1515), __webpack_require__.e(9118), __webpack_require__.e(4922)]).then(__webpack_require__.bind(__webpack_require__, 65630));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65630)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var MTIWomenPAProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1509), __webpack_require__.e(3917), __webpack_require__.e(768), __webpack_require__.e(8837), __webpack_require__.e(5865), __webpack_require__.e(3247), __webpack_require__.e(5518), __webpack_require__.e(6519), __webpack_require__.e(7784), __webpack_require__.e(1173), __webpack_require__.e(9474), __webpack_require__.e(6434), __webpack_require__.e(4811), __webpack_require__.e(1929), __webpack_require__.e(1515), __webpack_require__.e(9118), __webpack_require__.e(7069)]).then(__webpack_require__.bind(__webpack_require__, 5301));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5301)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var TIPPAProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1509), __webpack_require__.e(3917), __webpack_require__.e(768), __webpack_require__.e(8837), __webpack_require__.e(5865), __webpack_require__.e(3247), __webpack_require__.e(5518), __webpack_require__.e(6519), __webpack_require__.e(7784), __webpack_require__.e(1173), __webpack_require__.e(9474), __webpack_require__.e(6434), __webpack_require__.e(4811), __webpack_require__.e(1929), __webpack_require__.e(1515), __webpack_require__.e(9118), __webpack_require__.e(1419)]).then(__webpack_require__.bind(__webpack_require__, 47711));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47711)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var AXACancerProductCategoryDetail = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1509), __webpack_require__.e(3917), __webpack_require__.e(768), __webpack_require__.e(8837), __webpack_require__.e(5865), __webpack_require__.e(3247), __webpack_require__.e(5518), __webpack_require__.e(6519), __webpack_require__.e(7784), __webpack_require__.e(1173), __webpack_require__.e(9474), __webpack_require__.e(6434), __webpack_require__.e(4811), __webpack_require__.e(1929), __webpack_require__.e(1515), __webpack_require__.e(9118), __webpack_require__.e(6563)]).then(__webpack_require__.bind(__webpack_require__, 28115));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28115)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var EntryForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(7572), __webpack_require__.e(768), __webpack_require__.e(6434), __webpack_require__.e(1379)]).then(__webpack_require__.bind(__webpack_require__, 13656));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(13656)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var ProductCategoryPage = function(param) {
    var channelPath = param.channelPath, categoryCode = param.categoryCode, banner = param.banner, entryForm = param.entryForm, contentCode = param.contentCode, channelConfig = param.channelConfig;
    var content = channelConfig.content;
    var EntryFormComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryForm, {
        categoryCode: categoryCode,
        entryFormCode: entryForm === null || entryForm === void 0 ? void 0 : entryForm.code,
        entryFormHero: entryForm === null || entryForm === void 0 ? void 0 : entryForm.hero,
        activeInputCodes: entryForm === null || entryForm === void 0 ? void 0 : entryForm.activeInputCodes,
        channelPath: channelPath,
        channelCode: channelConfig.code
    });
    var categoryCodeToProductCategory = {
        "content-ret-child-health": /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildHealthProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ret-health": /*#__PURE__*/ (0,jsx_runtime.jsx)(HealthProductCategoryDetail, {
            banner: banner,
            categoryCode: categoryCode,
            entryForm: entryForm,
            channelPath: channelPath,
            categoryName: banner.title,
            channelConfig: channelConfig
        }),
        "content-ret-health-topup": /*#__PURE__*/ (0,jsx_runtime.jsx)(HealthTopUpProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ret-personal-accident": /*#__PURE__*/ (0,jsx_runtime.jsx)(PAProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ret-critical-illness": /*#__PURE__*/ (0,jsx_runtime.jsx)(CriticalIllnessProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ret-cancer": /*#__PURE__*/ (0,jsx_runtime.jsx)(CancerProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-thg-health": /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerHealthProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-thg-health-topup": /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerHealthTopupProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-thg-personal-accident": /*#__PURE__*/ (0,jsx_runtime.jsx)(THGPAProductCateogryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-thg-critical-illness": /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerCriticalIllnessProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-siw-health": /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerHealthProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-siw-health-topup": /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerHealthTopupProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-siw-personal-accident": /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerPAProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-siw-critical-illness": /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerCriticalIllnessProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-wth-health": /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerHealthProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-wth-health-topup": /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerHealthTopupProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-wth-personal-accident": /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerPAProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-wth-critical-illness": /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerCriticalIllnessProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-fpd-health": /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerHealthProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-fpd-health-topup": /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerHealthTopupProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-fpd-personal-accident": /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerPAProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-fpd-critical-illness": /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerCriticalIllnessProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-lgi-health": /*#__PURE__*/ (0,jsx_runtime.jsx)(LgibHealthProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-lgi-health-topup": /*#__PURE__*/ (0,jsx_runtime.jsx)(LgibHealthTopUpProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-lgi-personal-accident": /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerPAProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-lgi-critical-illness": /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerCriticalIllnessProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-ntl-health": /*#__PURE__*/ (0,jsx_runtime.jsx)(HGDHealthProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-ntl-health-topup": /*#__PURE__*/ (0,jsx_runtime.jsx)(HGDHealthTopUpProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-ntl-personal-accident": /*#__PURE__*/ (0,jsx_runtime.jsx)(HGDPAProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-ntl-critical-illness": /*#__PURE__*/ (0,jsx_runtime.jsx)(HGDCriticalIllnessProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-scb-personal-accident-foreign-woker": /*#__PURE__*/ (0,jsx_runtime.jsx)(ScbForeignWorkerPAProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-ksc-child-health": /*#__PURE__*/ (0,jsx_runtime.jsx)(KSCChildHealthProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-ksc-health": /*#__PURE__*/ (0,jsx_runtime.jsx)(KSCHealthProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ptn-ksc-health-topup": /*#__PURE__*/ (0,jsx_runtime.jsx)(KSCHealthTopUpProductCategoryDetail, {
            entryForm: EntryFormComponent
        }),
        "content-ret-motor-gasoline": /*#__PURE__*/ (0,jsx_runtime.jsx)(RetailMotorProductCategoryDetail, {
            banner: banner,
            categoryCode: categoryCode,
            entryForm: EntryFormComponent,
            channelPath: channelPath,
            categoryName: banner.title,
            channelConfig: channelConfig
        }),
        "content-ret-motor-ev": /*#__PURE__*/ (0,jsx_runtime.jsx)(EvRetailMotorProductCategoryDetail, {
            banner: banner,
            categoryCode: categoryCode,
            entryForm: EntryFormComponent,
            channelPath: channelPath,
            categoryName: banner.title,
            channelConfig: channelConfig
        }),
        "content-ret-chubb-travel": /*#__PURE__*/ (0,jsx_runtime.jsx)(CHUBBTravelProductCategoryDetail, {
            banner: banner,
            categoryCode: categoryCode,
            entryForm: entryForm,
            channelPath: channelPath,
            categoryName: banner.title,
            channelConfig: channelConfig
        }),
        "content-axa-child-health": /*#__PURE__*/ (0,jsx_runtime.jsx)(AXAChildHealthProductCategoryDetail, {
            banner: banner,
            categoryCode: categoryCode,
            entryForm: entryForm,
            channelPath: channelPath,
            categoryName: banner.title,
            channelConfig: channelConfig
        }),
        "content-axa-health": /*#__PURE__*/ (0,jsx_runtime.jsx)(AXAAdultHealthProductCategoryDetail, {
            banner: banner,
            categoryCode: categoryCode,
            entryForm: entryForm,
            channelPath: channelPath,
            categoryName: banner.title,
            channelConfig: channelConfig
        }),
        "content-axa-cancer": /*#__PURE__*/ (0,jsx_runtime.jsx)(AXACancerProductCategoryDetail, {
            banner: banner,
            categoryCode: categoryCode,
            entryForm: entryForm,
            channelPath: channelPath,
            categoryName: banner.title,
            channelConfig: channelConfig
        }),
        "content-bki-pa": /*#__PURE__*/ (0,jsx_runtime.jsx)(BKIPAProductCategoryDetail, {
            banner: banner,
            categoryCode: categoryCode,
            entryForm: entryForm,
            channelPath: channelPath,
            categoryName: banner.title,
            channelConfig: channelConfig
        }),
        "content-mti-child-pa": /*#__PURE__*/ (0,jsx_runtime.jsx)(MTIChildPAProductCategoryDetail, {
            banner: banner,
            categoryCode: categoryCode,
            entryForm: entryForm,
            channelPath: channelPath,
            categoryName: banner.title,
            channelConfig: channelConfig
        }),
        "content-mti-child-pa-health": /*#__PURE__*/ (0,jsx_runtime.jsx)(MTIChildPAHealthProductCategoryDetail, {
            banner: banner,
            categoryCode: categoryCode,
            entryForm: entryForm,
            channelPath: channelPath,
            categoryName: banner.title,
            channelConfig: channelConfig
        }),
        "content-mti-pneumonia-dengue": /*#__PURE__*/ (0,jsx_runtime.jsx)(MTIPneumoniaDengueProductCategoryDetail, {
            banner: banner,
            categoryCode: categoryCode,
            entryForm: entryForm,
            channelPath: channelPath,
            categoryName: banner.title,
            channelConfig: channelConfig
        }),
        "content-mti-women-pa": /*#__PURE__*/ (0,jsx_runtime.jsx)(MTIWomenPAProductCategoryDetail, {
            banner: banner,
            categoryCode: categoryCode,
            entryForm: entryForm,
            channelPath: channelPath,
            categoryName: banner.title,
            channelConfig: channelConfig
        }),
        "content-tip-pa": /*#__PURE__*/ (0,jsx_runtime.jsx)(TIPPAProductCategoryDetail, {
            banner: banner,
            categoryCode: categoryCode,
            entryForm: entryForm,
            channelPath: channelPath,
            categoryName: banner.title,
            channelConfig: channelConfig
        })
    };
    var ProductCategoryDetailBox = (0,lodash.get)(categoryCodeToProductCategory, contentCode) || EntryFormComponent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            !(entryForm.code === constants_entryForm/* ENTRY_FORM_CODE.MOTOR_BASIC_ENTRY_FORM */.K.MOTOR_BASIC_ENTRY_FORM || [
                "content-ret-health",
                "content-ret-chubb-travel",
                "content-axa-child-health",
                "content-axa-health",
                "content-bki-pa",
                "content-mti-child-pa",
                "content-mti-child-pa-health",
                "content-mti-pneumonia-dengue",
                "content-mti-women-pa",
                "content-tip-pa",
                "content-axa-cancer", 
            ].includes(contentCode)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryFormBanner, {
                title: banner.title,
                desktopImage: banner.desktopImage,
                mobileImage: banner.mobileImage,
                content: content
            }),
            ProductCategoryDetailBox,
            ![
                "content-ret-health",
                "content-ret-motor",
                "content-ret-chubb-travel",
                "content-axa-child-health",
                "content-axa-health",
                "content-bki-pa",
                "content-mti-child-pa",
                "content-mti-child-pa-health",
                "content-mti-pneumonia-dengue",
                "content-mti-women-pa",
                "content-tip-pa",
                "content-axa-cancer", 
            ].includes(contentCode) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUs, {
                content: channelConfig.content
            })
        ]
    });
};
/* harmony default export */ var components_ProductCategoryPage = (ProductCategoryPage);

;// CONCATENATED MODULE: ./src/pages/[channelPath]/[categoryCode]/index.tsx



var __N_SSP = true;
/* harmony default export */ var _categoryCode_ = ((0,withUserOrGuest/* default */.Z)((0,withLayout/* withLayout */.X)(components_ProductCategoryPage)));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,3640,6322,587,9774,2888,179], function() { return __webpack_exec__(41314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);